import { useMyTeams } from '@/features/admin/teams/hooks'
import { useAuthStore } from '@/features/auth/store'
import { useClaimTask, useUnclaimTask } from '../hooks'
import type { Task } from '../types'

interface ClaimButtonProps {
  task: Task
}

/**
 * Pokazuje "Podejmij" gdy:
 *  - assignee jest grupowy
 *  - task niezakłaimowany
 *  - current user należy do tej grupy (useMyTeams)
 *
 * Pokazuje "Zwolnij podjęcie" gdy current user jest claimerem.
 * W innych przypadkach renderuje null (USER-task, group spoza moich, claim cudzy).
 */
export function ClaimButton({ task }: ClaimButtonProps) {
  const { data: myTeams = [] } = useMyTeams()
  const currentUserId = useAuthStore((s) => s.user?.id ?? null)
  const claim = useClaimTask()
  const unclaim = useUnclaimTask()

  if (task.assignee.type !== 'GROUP') return null

  const myTeamIds = new Set(myTeams.map((t) => t.id))
  const isMyTeam = myTeamIds.has(task.assignee.group.id)
  const claimedByMe = task.claimedBy?.userId === currentUserId

  if (!task.claimedBy && isMyTeam) {
    return (
      <button
        type="button"
        className="rounded bg-emerald-600 px-3 py-1 text-sm text-white hover:bg-emerald-700 disabled:opacity-50"
        disabled={claim.isPending}
        onClick={() => claim.mutate(task.id)}
      >
        Podejmij
      </button>
    )
  }

  if (claimedByMe) {
    return (
      <button
        type="button"
        className="rounded border border-amber-500 px-3 py-1 text-sm text-amber-700 hover:bg-amber-50 disabled:opacity-50"
        disabled={unclaim.isPending}
        onClick={() => unclaim.mutate(task.id)}
      >
        Zwolnij podjęcie
      </button>
    )
  }

  return null
}
